<!-- eslint-disable import/no-named-as-default -->
<template>
  <div class="hero-banner" />
</template>

<script>

/**
 * Vue: Hero banner (hero-banner)
 * -----------------------------------------------------------------------------
 * Large media section that displays image/video.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import Splide from '@splidejs/splide'
export default {
  name: 'HeroBanner',
  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        blockLength: 0,
        autoplay: 0,
      }),
    },
  },

  data() {
    return {
      // interval:
    }
  },

  mounted() {
    if (this.liquid.blockLength > 1) {
      this.createCarousel()
    }
  },

  methods: {
    createCarousel() {
      const container = document.querySelector(`#vue-element .section-${this.liquid.sectionId}`)
      const carousel = container.querySelector('.splide')

      const autoplay = this.liquid.autoplay === 0 ? 'pause' : 'play'
      const interval = this.liquid.autoplay

      const splide = new Splide(carousel, {
        autoplay,
        interval,
        rewind: true,
        speed: 1000,
        type: 'fade',

      }).mount()

      if (autoplay === 'pause') {
        document.documentElement.style.setProperty(
          '--hero-banner-pagination-progress',
          `100% 100%`,
        )

        return
      }

      let progress = 100

      splide.on('autoplay:playing', (time) => {
        progress = (100 - (time * 100)) + 100

        document.documentElement.style.setProperty(
          '--hero-banner-pagination-progress',
          `100% ${progress}%`,
        )
      })

      splide.on('autoplay:pause', () => {
        document.documentElement.style.setProperty(
          '--hero-banner-pagination-progress',
          `100% ${progress}%`,
        )
      })
    },
  },
}
</script>

<style lang="scss">
@import './hero-banner';
@import '@/components/splide';
</style>
